export default __webpack_public_path__ + "locales/en/FilesSettings.json?hash=17bc0596889255e99c1ab0e35e2d7e6c";